import { useLocation } from 'react-router-dom';

/**
 * Frontend-only admin escape hatch for the benchmark-editor lock.
 *
 * Benchmark settings are normally read-only once a session leaves CREATING
 * (see {@link isSessionLocked}). Loading the trainer settings URL with the
 * secret `?unlockBenchmark` query param *present* keeps the benchmark editors
 * editable for that page load only.
 *
 * Deliberately NOT persisted (no localStorage): drop the param / reload and the
 * lock is back. Because it lives purely in the frontend it is an admin
 * convenience, not a security boundary — the backend imposes no such lock.
 */
export const BENCHMARK_EDIT_OVERRIDE_PARAM = 'unlockBenchmark';

export function useBenchmarkEditOverride(): boolean {
  const { search } = useLocation();
  return new URLSearchParams(search).has(BENCHMARK_EDIT_OVERRIDE_PARAM);
}
